import { createStore } from "vuex";

export default {
    namespaced: true,
    state: {
        layers: [],
        saveState: null
    },
    mutations: {
        SET_SAVE_STATE(state, saveState) {
            state.saveState = saveState
        }
    },
    actions: {
        async saveCreatorState({ commit }, {state}) {
            commit('SET_SAVE_STATE', state);
        },
    }
};